// StepTwo.js
import React from "react";
import { useTranslation } from "react-i18next"; // 🆕 add i18n

function StepTwo({
  formData,
  formErrors,
  touched,
  validUserError,
  handleChange,
  handleBlur,
  showPassword,
  showConfirmPassword,
  togglePasswordVisibility,
  toggleConfirmPasswordVisibility,
}) {
  const { t } = useTranslation("register");     // 🆕 namespace

  return (
    <>
      <div className="form-group-unique">
        <label htmlFor="email">{t("stepTwo.labels.email")}</label>      {/* ⬅️ i18n */}
        <input
          type="text"
          id="email"
          name="email"
          value={formData.email}
          onChange={handleChange}
          onBlur={handleBlur}
        />
        {touched.email && (formErrors.email || validUserError) && (
          <p className="error">{formErrors.email || validUserError}</p>
        )}
      </div>

      <div className="form-group-unique">
        <label htmlFor="phoneNumber">{t("stepTwo.labels.phone")}</label> {/* ⬅️ i18n */}
        <input
          type="text"
          id="phoneNumber"
          name="phoneNumber"
          value={formData.phoneNumber}
          onChange={handleChange}
          onBlur={handleBlur}
        />
        {touched.phoneNumber && formErrors.phoneNumber && (
          <p className="error">{formErrors.phoneNumber}</p>
        )}
      </div>

      <div className="form-group-unique">
        <label htmlFor="password">{t("stepTwo.labels.password")}</label> {/* ⬅️ i18n */}
        <div className="password-input-unique">
          <input
            type={showPassword ? "text" : "password"}
            id="password"
            name="password"
            value={formData.password}
            onChange={handleChange}
            onBlur={handleBlur}
          />
          <span
            className="toggle-password-unique"
            onClick={togglePasswordVisibility}
          >
            <img
              src={showPassword ? "/eye.svg" : "/eye-slash.svg"}
              alt="toggle visibility"
            />
          </span>
        </div>
        {touched.password && formErrors.password && (
          <p className="error">{formErrors.password}</p>
        )}
      </div>

      <div className="form-group-unique">
        <label htmlFor="passwordConfirm">
          {t("stepTwo.labels.confirmPassword")}                         {/* ⬅️ i18n */}
        </label>
        <div className="password-input-unique">
          <input
            type={showConfirmPassword ? "text" : "password"}
            id="passwordConfirm"
            name="passwordConfirm"
            value={formData.passwordConfirm}
            onChange={handleChange}
            onBlur={handleBlur}
          />
          <span
            className="toggle-password-unique"
            onClick={toggleConfirmPasswordVisibility}
          >
            <img
              src={showConfirmPassword ? "/eye.svg" : "/eye-slash.svg"}
              alt="toggle visibility"
            />
          </span>
        </div>
        {touched.passwordConfirm && formErrors.passwordConfirm && (
          <p className="error">{formErrors.passwordConfirm}</p>
        )}
      </div>
    </>
  );
}

export default StepTwo;
